<template>
  <page>
    <page-title v-t="'p.confirmInvitationPage.title'"/>

    <div class="invitation__message">
      {{ error ? $t('p.confirmInvitationPage.message.error') : $t('p.confirmInvitationPage.message.success') }}
    </div>
  </page>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'ConfirmInvitationPage',
  mixins: [PageMixin],
  computed: {
    ...mapState({
      invitation: state => state.invitation.invitation,
      error: state => state.invitation.request.error
    }),
    token () {
      return this.$route.params.token
    }
  },
  methods: {
    ...mapActions([
      'confirmInvitation'
    ])
  },
  created () {
    this.confirmInvitation(this.token)
    this.$emit('loadingDone')
  }
}
</script>

<style lang="sass">
.invitation__message
  text-align: center
</style>




// WEBPACK FOOTER //
// src/pages/invitations/ConfirmInvitationPage.vue